import { jsx as e, Fragment as i, jsxs as s } from "react/jsx-runtime";
import '../Divider.css';const a = "_dividerWrapper_16o3s_1", t = "_divider_16o3s_1", c = "_text_16o3s_11", r = {
  dividerWrapper: a,
  divider: t,
  text: c
}, n = ({ text: d }) => /* @__PURE__ */ e(i, { children: d ? /* @__PURE__ */ s("div", { className: r.dividerWrapper, "data-cxy-name": "divider", children: [
  /* @__PURE__ */ e("hr", { className: r.divider }),
  /* @__PURE__ */ e("span", { className: r.text, children: d }),
  /* @__PURE__ */ e("hr", { className: r.divider })
] }) : /* @__PURE__ */ e("hr", { className: r.divider, "data-cxy-name": "divider" }) });
export {
  n as Divider
};
